// extracted by mini-css-extract-plugin
export default {"Container":"AuthLogin_Container__Ny9gy","AuthLogin":"AuthLogin_AuthLogin__lisOL","Header":"AuthLogin_Header__7jqfp","Form":"AuthLogin_Form__n59at","Error":"AuthLogin_Error__G1XXz"};